import { useQuery } from '@apollo/client';
import { useEffect, useRef, useState } from 'react';
import { debounce } from 'lodash';
import {
    CITRIN_GET_MAP_TAXI_BUSINESS_USERS,
    GetMapTaxiBusinessUsersRequest,
    GetMapTaxiBusinessUsersResponse,
} from '..';
import { MapTaxiBusinessUsersQueryFilter } from '../../shared/types';

export const useGetMapTaxiBusinessUsersQuery = (request: MapTaxiBusinessUsersQueryFilter, debounceTime?: number) => {
    const [internalRequest, setInternalRequest] = useState(() => request);
    const debounced = useRef(
        debounce(
            (newRequest: MapTaxiBusinessUsersQueryFilter) => {
                setInternalRequest(newRequest);
            },
            debounceTime ?? 100,
            { leading: false, trailing: true }
        )
    ).current;
    useEffect(() => {
        return debounced(request);
    }, [request]);

    const { data, previousData, ...rest } = useQuery<GetMapTaxiBusinessUsersResponse, GetMapTaxiBusinessUsersRequest>(
        CITRIN_GET_MAP_TAXI_BUSINESS_USERS,
        {
            variables: { request: internalRequest },
            fetchPolicy: 'network-only',
            // onCompleted: (data) => console.log('[MGT] Pricing', data),
        }
    );

    return {
        ...rest,
        previousData: previousData?.CITRIN_MGT_getMapTaxiBusinessUsers,
        data: data?.CITRIN_MGT_getMapTaxiBusinessUsers,
    };
};
